<template>
  <!-- <transition name="transition-flash"> -->
  <StyledFlashMessage
    :message-type="messageType"
    :class="`payment-header__flash-message payment-header__flash-message--${messageType}`"
  >
    <div class="payment-header__flash-message__notification">
      <div class="message-title">
        <span v-if="error">{{ message.text }}</span>
      </div>

      <div v-if="showDetails" class="flash-message__details">
        {{ message.additionalInfo }}
      </div>
    </div>

    <div class="flash-message__close">
      <span class="show-details" @click="showDetails = !showDetails">{{ $t(detailsPhrase) }}</span>

      <div @click="close">
        <mob-search-close-svg :fill="'#fff'" />
      </div>
    </div>
  </StyledFlashMessage>
  <!-- </transition> -->
</template>

<script>
import MobSearchCloseSvg from '@/components/svg/MobSearchClose';
import styled from 'vue-styled-components';

const StyledFlashMessage = styled('div', {
  messageType: String,
})`
  border-radius: var(--border_radius);
  background-color: ${props =>
    props.messageType === 'error'
      ? `var(--error)`
      : props.messageType === 'success'
      ? `var(--success)`
      : '#e65639'};
  .message-title {
    width: 50%;
  }
`;

export default {
  components: {
    MobSearchCloseSvg,
    StyledFlashMessage,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showDetails: false,
      error: {
        data: {
          errors: true,
        },
      },
    };
  },

  computed: {
    messageType() {
      return this.message.type;
    },
    detailsPhrase() {
      return this.showDetails ? 'hide-details' : 'show-details';
    },
  },
  mounted() {
    console.log('Message mpounted', this.message);
  },
  methods: {
    close() {
      this.$emit('close', this.message);
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-header__flash-message {
  z-index: 1000;
  position: absolute;
  position: relative;

  color: #fff;

  &__notification {
    padding: 20px;
    text-align: left;
    min-height: 60px;
  }

  .flash-message__close {
    position: absolute;
    right: 15px;
    top: 20px;
    height: 20px;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;

    .show-details {
      cursor: pointer;
      padding-right: 10px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__step {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
    line-height: 1.33;
    &__description {
      color: #d7d8db;
    }

    &__step-number {
      color: #78797a;
    }
  }

  /*&--error {*/
  /*  background-color: #e65639;*/
  /*  box-shadow: 0 3px 6px 0 rgba(128, 48, 32, 0.25);*/
  /*}*/

  &--warning {
    background-color: #e6a23c;
    box-shadow: 0 3px 6px 0 rgba(128, 48, 32, 0.25);
  }

  &--blue {
    background-color: #0055cc;
  }

  &--dark {
    background-color: #2d3440;
  }
}
</style>
